<div class="fc-job-form-card">

  <div class="fc-job-form-head">
    <h3 class="fc-job-form-title">Job order details</h3>
  </div>

  <form class="fc-job-form" [formGroup]="formGroup">
    <div class="fc-job-form-grid">

      <mat-form-field appearance="outline">
        <mat-label>Job name *</mat-label>
        <input matInput formControlName="code" required minlength="1" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Customer</mat-label>
        <input matInput formControlName="customer" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Delivery date</mat-label>
        <input matInput [matDatepicker]="deliveryDate" formControlName="deliveryDate" />
        <mat-datepicker-toggle matSuffix [for]="deliveryDate"></mat-datepicker-toggle>
        <mat-datepicker #deliveryDate></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Job name by customer</mat-label>
        <input matInput formControlName="nameByCustomer" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Description</mat-label>
        <input matInput formControlName="description" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Difficulty</mat-label>
        <input matInput placeholder="Number" formControlName="difficulty" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="fc-field-full">
        <mat-label>Note</mat-label>
        <textarea matInput formControlName="note" rows="3"></textarea>
      </mat-form-field>

    </div>
  </form>

  <div class="fc-job-form-footer">
    <button class="fc-btn fc-btn--secondary" (click)="onCancelClicked()">Cancel</button>
    <button class="fc-btn fc-btn--primary" [disabled]="!formGroup.valid" (click)="onOkClicked()">Save</button>
  </div>

</div>
